import { render, staticRenderFns } from "./editFee.vue?vue&type=template&id=708ccb74&scoped=true"
import script from "./editFee.vue?vue&type=script&lang=js"
export * from "./editFee.vue?vue&type=script&lang=js"
import style0 from "./editFee.vue?vue&type=style&index=0&id=708ccb74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ccb74",
  null
  
)

export default component.exports